var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertymenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 21,
    viewBox: "0 0 5 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50297 12.185C1.57263 12.185 0.818441 11.4308 0.818441 10.5004C0.818441 9.57011 1.57263 8.81592 2.50297 8.81592C3.43331 8.81592 4.1875 9.57011 4.1875 10.5004C4.1875 11.4308 3.43331 12.185 2.50297 12.185Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50297 3.76213C1.57263 3.76213 0.818441 3.00794 0.818441 2.0776C0.818441 1.14726 1.57263 0.393066 2.50297 0.393066C3.43331 0.393066 4.1875 1.14726 4.1875 2.0776C4.1875 3.00794 3.43331 3.76213 2.50297 3.76213Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50297 20.6073C1.57263 20.6073 0.818441 19.8532 0.818441 18.9228C0.818441 17.9925 1.57263 17.2383 2.50297 17.2383C3.43331 17.2383 4.1875 17.9925 4.1875 18.9228C4.1875 19.8532 3.43331 20.6073 2.50297 20.6073Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertymenu);
export default __webpack_public_path__ + "static/media/propertymenu.fca27686a3ec0f2ee43dd71aeaab75ad.svg";
export { ForwardRef as ReactComponent };